import { EVENTS as DIALOG_EVENTS } from 'www/vue_components/common/core/BaseDialog/constants'
import { dispatchCustomEventGlobally } from 'www/utils'
import { DIALOG_ERROR_CONFIG } from '../constants'

export function showCommonErrorMessage() {
  dispatchCustomEventGlobally(DIALOG_EVENTS.open, DIALOG_ERROR_CONFIG)
}
